<div class="ea-scrolledheader"
    [ngClass]="{'ee-scrolled-s': showScrolledS, 'ee-scrolled-m': showScrolledM , 'ee-scrolled-l': showScrolledL}">
    <router-outlet></router-outlet>
</div>